import { render, staticRenderFns } from "./DetailStore.vue?vue&type=template&id=1148b090"
import script from "./DetailStore.vue?vue&type=script&lang=js"
export * from "./DetailStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports